import React from "react";
import Bookings from "./../Bookings/Bookings";
import Preview from "./../Preview/Preview";
import PurityCalculator from "./../PurityCalculator/PurityCalculator";
import Collector from "./../Collector/Collector";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { updateGeneralInfo } from "../../store/General/general.action";

export default function General() {
  const generalInfo = useSelector((state) => state.generalInfo, shallowEqual);
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    let tempGeneralInfo = [...generalInfo.generalInfo];
    if (event.target.name === "custName") {
      tempGeneralInfo[0].custName = event.target.value;
    }

    dispatch(updateGeneralInfo(tempGeneralInfo));
  };

  const handleDateChange = (date) => {
    let tempGeneralInfo = [...generalInfo.generalInfo];
    date ? (tempGeneralInfo[0].challanDate = date) : Date.now();
    dispatch(updateGeneralInfo(tempGeneralInfo));
  };

  return (
    <div>
      <div className="container">
        <div className="row align-items-start">
          <div className="col-6">
            <div className="row align-items-start" style={{ margin: "10px" }}>
              <div className="col-6">
                <input
                  className="form-control"
                  type="date"
                  id="date"
                  name="date"
                  value={generalInfo.generalInfo[0].challanDate}
                  onChange={(e) => handleDateChange(e.target.value)}
                ></input>
              </div>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Customer Name"
                  id="custName"
                  name="custName"
                  value={generalInfo.generalInfo[0].custName}
                  onChange={(event) => handleInputChange(event)}
                />
              </div>
            </div>

            <Bookings />
            <PurityCalculator />
            <Collector />
          </div>
          <div className="col-6">
            <Preview />
          </div>
        </div>
      </div>
    </div>
  );
}
